module.exports = "/_next/static/images/Calendar-c9e34fb9738d91d08fe46aa4fe30490a.svg";